// From https://stackoverflow.com/questions/31430167/regex-check-if-given-string-is-relative-url
export const relativeUrlPattern = new RegExp('^(?!www.|(?:http|ftp)s?://|[A-Za-z]:\\|//).*')
